<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {

    }
  },
  mounted () {
    // if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
    //   this.$router.push('/mobile')
    // } else {
    //   this.$router.push('/')
    // }
    // if(/Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent)){
    //     localStorage.setItem('isSafari',1)
    // }else{
    //     localStorage.setItem('isSafari',0)
    // }
  }
}
</script>

<style lang="scss">
@import "./../static/css/reset.css";
@import "./../static/css/public.min.css";

#app {
  font-family: PingFangSC-Regular, sans-serif;
  height: 100%;
  width: 100%;
  margin: 0rem;
  padding-left: constant(safe-area-inset-left);
  padding-left: env(safe-area-inset-left);
  padding-right: constant(safe-area-inset-right);
  padding-right: env(safe-area-inset-right);
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}

.mint-popup {
  width: 100%;
  height: 100%;
}

html,
body {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/App.vue